import { PropTypes } from 'preact-compat';
import { createSelector } from 'reselect';
import { actionTypes } from '../actions';
import { CATEGORY_LEVELS, selectCategories } from './categories';

export const featuredServiceItemShape = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  imgUrl: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

export const proItemShape = PropTypes.shape({
  avatarUrl: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  lastName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
  pro: PropTypes.shape({
    costPerMinute: PropTypes.number.isRequired,
    service: PropTypes.string.isRequired,
    serviceDescription: PropTypes.string.isRequired,
    review: PropTypes.shape({
      rating: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  state: PropTypes.shape({
    activeNow: PropTypes.bool.isRequired,
    onCall: PropTypes.bool.isRequired,
    dateLastActive: PropTypes.string,
  }).isRequired,
});

export const prosSearchResultShape = PropTypes.shape({
  circle: PropTypes.arrayOf(proItemShape).isRequired,
  filtered: PropTypes.arrayOf(proItemShape).isRequired,
  relevant: PropTypes.arrayOf(proItemShape).isRequired,
  featuredServices: PropTypes.arrayOf(featuredServiceItemShape).isRequired,
});

// Constants (down)

export const moduleName = 'findPro';

export const SORT_TYPE = {
  BY_ACTIVITY: 'by_activity',
  BY_EXPERIENCE: 'by_experience',
  BY_LOWEST_RATE: 'by_lowest_rate',
  BY_HIGHEST_RATE: 'by_highest_rate',
  BY_RATING: 'by_rating',
};

// Constants (up)

// Reducer (down)

const initialState = {
  processed: false,
  processing: false,
  searchPhrase: '',
  sort: SORT_TYPE.BY_ACTIVITY,
  activeFilterTags: {
    categories: [],
    sectors: [],
    services: [],
  },
  entities: {
    circle: [],
    filtered: [],
    relevant: [],
    featuredServices: [],
  },
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FIND_PRO_FILTER_REQUEST:
      return {
        ...state,
        processed: false,
        processing: true,
        entities: initialState.entities,
      };

    case actionTypes.FIND_PRO_FILTER_SUCCESS: {
      const { pros } = payload;

      return {
        ...state,
        processed: true,
        processing: false,
        entities: { ...pros },
      };
    }

    case actionTypes.FIND_PRO_FILTER_FAILURE:
      return {
        ...state,
        processed: false,
        processing: false,
        entities: initialState.entities,
      };

    case actionTypes.FIND_PRO_SET_ACTIVE_FILTER_TAGS: {
      const { activeFilterTags } = payload;

      return {
        ...state,
        activeFilterTags,
      };
    }

    case actionTypes.FIND_PRO_SET_SORT: {
      const { sort } = payload;

      return {
        ...state,
        sort,
      };
    }

    case actionTypes.FIND_PRO_SET_SEARCH_PHRASE: {
      const { searchPhrase } = payload;

      return {
        ...state,
        searchPhrase,
      };
    }

    case actionTypes.FIND_PRO_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

// Reducer (up)

// Selectors (down)

const stateSelector = (state) => state[moduleName];

export const selectFindProProcessing = createSelector(
  stateSelector, (findPro) => findPro.processing,
);

export const selectFindProSearchPhrase = createSelector(
  stateSelector, (findPro) => findPro.searchPhrase,
);

export const selectFindProSort = createSelector(
  stateSelector, (findPro) => findPro.sort,
);

export const selectFindProActiveFilterTags = createSelector(
  stateSelector, (findPro) => findPro.activeFilterTags,
);

export const selectFindProEntities = createSelector(
  stateSelector, (findPro) => findPro.entities,
);

export const selectCategoriesFilters = createSelector(
  selectCategories,
  selectFindProActiveFilterTags,
  (entities, activeFilterTags) => (
    /**
     * @property {[{}]} childs
     */
    entities.map((sector) => ({
      ticked: activeFilterTags.sectors.includes(sector.tag),
      label: sector.name,
      level: CATEGORY_LEVELS.SECTORS,
      tag: sector.tag,
      children: sector.childs.map((category) => ({
        ticked: activeFilterTags.categories.includes(category.tag),
        label: category.name,
        level: CATEGORY_LEVELS.CATEGORIES,
        tag: category.tag,
        children: category.childs.map((service) => ({
          ticked: activeFilterTags.services.includes(service.tag),
          level: CATEGORY_LEVELS.SERVICES,
          label: service.name,
          tag: service.tag,
          children: [],
        })),
      })),
    }))
  ),
);

// Selectors (up)



// WEBPACK FOOTER //
// ./reducers/findPro.js